import { LinearProgress, Typography, Box, styled } from "@mui/material";

function RemainingBar({ data }) {
  if (!data?.dayInvestment || data.remainingDays == null) return null;

  const { remainingDays, dayInvestment } = data

  const passedDays = dayInvestment - (dayInvestment - remainingDays);
  const progressValue = (passedDays / dayInvestment) * 100;

  return (
    <Box maxWidth={"120px"}>
      <Typography variant="subtitle2">
        {remainingDays <= 0 ? "Expired" : `${remainingDays} Days Remaining`}
      </Typography>

      {remainingDays <= 0 ? null :
        <Linear
          variant="determinate"
          color="secondary"
          value={progressValue}
        />
      }
    </Box>
  );
}

const Linear = styled(LinearProgress)(({ theme }) => ({
  height: "8px",
  borderRadius: "12px",
  "&.MuiLinearProgress-root": {
    backgroundColor: "rgb(181 181 181)",
  },
  ".MuiLinearProgress-bar": {
    backgroundColor: "#3498db",
  },
}));

const RemainingText = styled("span")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export default RemainingBar;
